import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { CompanyOwnerDto } from '../types/dtos';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<CompanyOwnerDto, string>({
        query: (id) => `${APP_ENDPOINTS.COMPANY_OWNER}/${id}`,
        providesTags: [{ type: 'company-owner', id: 'GET-ID' }],
    });
